import React, {useEffect, useState} from "react";
import {
	Button,
	CardBody,
	CardHeader,
	Collapse,
} from "reactstrap";
import QRCode from "qrcode.react";
import "./styles/main.css";
import Icon from "../../components/Icon";
import introImgLight from "../../assets/images/intro-connection-light.jpg";
import introImgDark from "../../assets/images/intro-connection-dark.jpg";
import chatConversation from "../../assets/images/chat_conversation.png"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons/faWhatsapp";
import {getConnectionStatus, getSessionValue, isMobile} from "../../../../Common/Appcommon";
import {useUsersContext} from "../../context/usersContext";
import Sidebar from "../../components/Sidebar";

const Home = () => {
	const { users } = useUsersContext();
	const darkTheme = document.body.classList.contains("dark-theme");
	const [connectionName, setConnectionName] = useState("");
	const [hash, setHash] = useState("");
	const [sandboxNumber, setSandboxnumber] = useState("");
	const [sendMsgPanelStatus, setSendMsgPanelStatus] = useState(true);
	const [connectApiPanelStatus, setConnectCloudAPIPanelStatus] = useState(false);
	const [whatsappMessage, setWhatsappMessage] = useState("");
	const [whatsappLink, setWhatsappLink] = useState("");
	const loginUser = getSessionValue('loginusername');


	useEffect(() => {
		(async () => {
			let wpconnectionName = await getWPConnectionStatus();

			if(users.length > 0){
				let userId = users[0]['cid'];
				if(wpconnectionName !== "no-connection" && !isMobile()) {
					window.location.href = "#/inbox/chat/" + userId;
				}
			}
		})();
		return () => {
			// this now gets called when the component unmounts
		};
	}, []);

	const getWPConnectionStatus = async () => {
		let response = await getConnectionStatus();
		let wpconnectionName = "";
		if(response.issuccess){
			let data = response.data;
			let connectionName = data['connection'];
			wpconnectionName = connectionName;
			let hash = data['hash'];
			let sandboxNumber = data['sandboxnumber'];
			let message = data['message'];
			let whatsappLink = data['link'];
			setHash(hash);
			setConnectionName(connectionName);
			setSandboxnumber(sandboxNumber);
			setWhatsappMessage(message);
			setWhatsappLink(whatsappLink);
		}
		return wpconnectionName;
	}

	const openSendMessagePanel = () => {
		if(connectionName === "sandbox"){
			setSendMsgPanelStatus(false);
		} else if(connectionName == "no-connection"){
			setSendMsgPanelStatus(!sendMsgPanelStatus);
		}
	}

	const openConnectCloudAPIPanel = () => {
		setConnectCloudAPIPanelStatus(!connectApiPanelStatus)
	}

	const openCloudAPIPanel = () => {
		window.location = "#/settings";
	}
	return (
		<div className="">
			{isMobile() && <Sidebar />}
			{!isMobile() && <div>
			{connectionName == "cloudapi" || connectionName == "" ? <div className={"home"}>
				<div className="home__img-wrapper">
					<img
						src={chatConversation}//darkTheme ? introImgDark : introImgLight}
						alt=""
						className="home__img"
					/>
				</div>

				<h1 className="home__title"> No conversations found  </h1>
				<p className="home__text">
					Choose any contact to initiate a new conversation
				</p>
				<p className="home__text hide">

					<Icon id="laptop" className="home__icon"/>
					<span>
					WhatsApp is available for Mac.{" "}
						<a
							href="https://www.whatsapp.com/download"
							target="_blank"
							className="home__link"
						>
						{" "}
							Get it here
					</a>
					.
				</span>
				</p>
			</div> : <div className={'sandbox-home pb-5'}>


					<div className={'sandbox-content border-none ml-3'}>
						<p className={'sandbox-header'}>{`Welcome ${loginUser} !`}</p>
						<ul className={'sandbox-connection-points'}>
							<li>Test with demo account with temporary WhatsApp Number</li>
							<li>You can chat with up to two users per day in sandbox mode.</li>
						</ul>
					</div>


				<div className={"sandbox-connection-steps"}>
					<div className={`automation-stepnumber ${!sendMsgPanelStatus ? 'icon-disabled' : ''}`}><FontAwesomeIcon icon={faCheck} /></div>
					<div className={'sandbox-content sendmsg-step'}>
						<CardHeader id="headingOne">
							<Button block color="link" className="text-start m-0 p-0" onClick={() => openSendMessagePanel()}
									aria-expanded={sendMsgPanelStatus} aria-controls="collapseOne">
								{sendMsgPanelStatus ? <p className={'sandbox-header'}>Send your first message</p> : <h5 className="m-0 p-0">Send your first message</h5>}
							</Button>
						</CardHeader>
						<Collapse isOpen={sendMsgPanelStatus} data-parent="#accordion" id="collapseOne" aria-labelledby="headingOne">
							<CardBody>
								<div className={'sm-options'}>
									<div className={'sm-content-option sm-scanner'}>
										<div className={'scanner'}>
											<QRCode
												value={whatsappLink} style={{ marginRight: 50 }}/>

										</div>
										<div className={'scanner-desc'}>
											<p className="scanner-desc-header">Scan the QR code </p><br/>
											<p className="scanner-desc-content">
												Scanning this QR Code will open up
												WhatsApp with a pre-filled message. Just hit 'Send' and see the
												message appear in the Shared Team Inbox.
											</p>
										</div>
									</div>
									<div className={'sm-content-option sm-divider'}>
										<div className={'divider-content'}>
										</div>
										<div className={'divider-condition-content'}>
											OR
										</div>
									</div>
									<div className={'sm-content-option sm-wp-link'}>
										<div className={'wp-link-content'}>
											<div className={'wp-link-img'}>
												<FontAwesomeIcon className={'wp-icon'} icon={faWhatsapp} />
											</div>
										</div>
										<div className={'wp-link-text-content'}>
											<p className="scanner-desc-header">Send WhatsApp message manually </p>
											<p className="scanner-desc-content">
												Simply click the below link to send a WhatsApp message to this number. This link will directly open WhatsApp for you.
											</p>
											<div className={'open-link'}>
												<a href={whatsappLink} target="_blank">{whatsappLink}</a>
											</div>
										</div>
									</div>
								</div>
							</CardBody>
						</Collapse>
					</div>
				</div>
				<div className={"sandbox-connection-steps"}>
					<div className={`automation-stepnumber ${!connectApiPanelStatus ? 'icon-disabled' : ''}`}><FontAwesomeIcon icon={faCheck} /></div>
					<div className={'sandbox-content connectapi-step'}>
						<CardHeader id="headingOne">
							<Button block color="link" className="text-start m-0 p-0" onClick={() => openConnectCloudAPIPanel()}
									aria-expanded={connectApiPanelStatus} aria-controls="collapseOne">
								{connectApiPanelStatus ? <p className={'sandbox-header'}>Connect your own number</p> : <h5 className="m-0 p-0">Connect your own number</h5>}
							</Button>
						</CardHeader>
						<Collapse isOpen={connectApiPanelStatus} data-parent="#accordion" id="collapseOne" aria-labelledby="headingOne">
							<CardBody>
								<p className="scanner-desc-content">
									Connect your WhatsApp Business account using Cloud API. (Recommended)
								</p>
								<Button className={'connect-api-btn'} color="success" onClick={openCloudAPIPanel}>
									Connect your own number
								</Button>
							</CardBody>
						</Collapse>
					</div>
				</div>
			</div>
			}
			</div>}
		</div>
	);
};

export default Home;
